import { render, staticRenderFns } from "./DocumentAllergiesTabContent.vue?vue&type=template&id=eed3a576&scoped=true&"
import script from "./DocumentAllergiesTabContent.vue?vue&type=script&lang=js&"
export * from "./DocumentAllergiesTabContent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAllergiesTabContent.vue?vue&type=style&index=0&id=eed3a576&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed3a576",
  null
  
)

export default component.exports